import { Component, OnInit } from '@angular/core';
import { ModalBaseComponent } from '../../../shared/components/modal-base/modal-base.component';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ApiError } from '../../../core/models/common/api-error';
import { FormValidationService } from '../../../core/services/form-validation.service';
import { Router } from '@angular/router';
import { ToastService } from '../../../core/services/toast.service';
import { RatesService } from '../../../core/services/rates.service';
import { ModalService } from '../../../core/services/modal.service';
import { Store } from '@ngrx/store';
import { ratesActions } from 'angular/app/core/store/rates';
import { Rate } from '../../../core/models/entities/rate';

@Component({
  selector: 'app-create-rate-modal',
  template: `
    <app-modal [modalInstance]="modalInstance" (onOk)="onSubmit()">
      <app-text-input
        label="Nom du groupe de tarif"
        name="name"
        [control]="form.get('name')"
      ></app-text-input>
    </app-modal>
  `,
  standalone: false,
})
export class CreateRateModalComponent
  extends ModalBaseComponent
  implements OnInit
{
  sendingData: boolean;
  form: UntypedFormGroup;
  constructor(
    private ratesService: RatesService,
    private formValidationService: FormValidationService,
    private toastService: ToastService,
    private router: Router,
    private modalService: ModalService,
    private store: Store,
  ) {
    super();
  }

  ngOnInit() {
    this.form = new UntypedFormGroup({
      name: new UntypedFormControl('', [Validators.required]),
    });
  }

  async onSubmit() {
    if (this.formValidationService.validate(this.form)) {
      try {
        this.modalInstance.saving = true;
        const rate: Rate = await this.ratesService.store({
          ...this.form.value,
        });

        this.store.dispatch(ratesActions.add({ rate }));
        this.modalService.close();
      } catch (exception) {
        this.formValidationService.displayApiValidationErrors(
          this.form,
          exception as ApiError,
        );
      } finally {
        this.modalInstance.saving = false;
      }
    }
  }
}
